import { makeStyles, tokens } from "@fluentui/react-components";
import { ReactNode } from "react";

interface StickyTopBannerStackProps {
  children: ReactNode;
}

const useStyles = makeStyles({
  root: {
    position: "sticky",
    top: "calc(var(--vsaa-header-height, 0px) + var(--vsaa-system-banner-height, 0px))",
    zIndex: 998,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  stack: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS,
  },
});

export const StickyTopBannerStack = ({
  children,
}: StickyTopBannerStackProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.stack}>{children}</div>
    </div>
  );
};
